/** Fonctions (intitulés de poste) proposées à la saisie d'un contact.
 *
 *  Rangées par famille de métier pour un menu déroulant lisible ; la liste
 *  plate `FONCTIONS_CONTACT` en découle. La saisie libre reste possible
 *  (« Autre… ») : la valeur part en clair dans `contact.fonction`, aucun code
 *  ne dépend de son contenu, et les intitulés du terrain débordent toujours
 *  d'une liste fermée.
 *
 *  Les formes féminines ne figurent que là où l'usage les distingue vraiment
 *  (Gérante, Directrice…) : le reste est épicène (Comptable, Responsable…).
 */
export const FONCTIONS_GROUPES = [
  { famille: "Direction", fonctions: [
    "Gérant", "Gérante", "Cogérant", "Président", "Présidente", "Président-directeur général",
    "Directeur général", "Directrice générale", "Directeur général adjoint",
    "Directeur de site", "Directeur d'agence", "Fondateur", "Fondatrice", "Associé", "Associée",
    "Propriétaire", "Chef d'entreprise", "Artisan"] },
  { famille: "Commercial et vente", fonctions: [
    "Directeur commercial", "Directrice commerciale", "Responsable commercial",
    "Commercial", "Commerciale", "Vendeur", "Vendeuse", "Responsable de magasin", "Chef des ventes",
    "Chargé d'affaires", "Chargée d'affaires", "Responsable marketing", "Chargé de communication"] },
  { famille: "Administration et finance", fonctions: [
    "Directeur administratif et financier", "Responsable administratif", "Responsable financier",
    "Chef comptable", "Comptable", "Assistant de direction", "Assistante de direction",
    "Office manager", "Secrétaire", "Accueil"] },
  { famille: "Achats et logistique", fonctions: [
    "Directeur des achats", "Responsable achats", "Acheteur", "Acheteuse",
    "Responsable logistique", "Responsable approvisionnement"] },
  { famille: "Technique et exploitation", fonctions: [
    "Directeur technique", "Responsable technique", "Responsable d'exploitation",
    "Responsable de production", "Responsable maintenance", "Conducteur de travaux",
    "Chef de chantier", "Chef d'atelier", "Technicien", "Technicienne", "Ingénieur"] },
  { famille: "Informatique", fonctions: [
    "Directeur des systèmes d'information", "Responsable informatique", "Administrateur réseau"] },
  { famille: "Ressources humaines, qualité et sécurité", fonctions: [
    "Directeur des ressources humaines", "Responsable des ressources humaines",
    "Chargé de recrutement", "Responsable QSE", "Responsable sécurité"] },
];

export const FONCTIONS_CONTACT = FONCTIONS_GROUPES.flatMap((g) => g.fonctions);
